import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { replaceMergeFields } from "../../../../features/leads/lead-view/lead-view-details/lead-view-details-view/lead-view-details-view-email-info/email-letter-helper";
import { $getRoot, $insertNodes as lexicalInsertNodes } from "lexical";

interface ReplaceMergeFieldsPluginProps {
  placeHolderValues: any;
  templateMetaData: any;
}

const ReplaceMergeFieldsPlugin = ({
  placeHolderValues,
  templateMetaData,
}: ReplaceMergeFieldsPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    let isUpdating = false;

    return editor.registerUpdateListener(({ editorState }) => {
      if (isUpdating) return;

      editorState.read(() => {
        const html = $generateHtmlFromNodes(editor);
        const replacedHtml = replaceMergeFields(
          html,
          placeHolderValues,
          templateMetaData
        );

        if (replacedHtml !== html) {
          isUpdating = true;

          editor.update(() => {
            const parser = new DOMParser();
            const dom = parser.parseFromString(replacedHtml, "text/html");
            const nodes = $generateNodesFromDOM(editor, dom);

            // Clear the root without replacing the entire editor state
            const root = $getRoot();
            root.clear();

            // Insert the new nodes
            lexicalInsertNodes(nodes);
          });

          isUpdating = false;
        }
      });
    });
  }, [editor, placeHolderValues, templateMetaData]);

  return null;
};

export default ReplaceMergeFieldsPlugin;
